import { handlePostApi, handleUpdatePostApi } from '@/api/crud';
import { barcodeApiEndPoints } from '@/api/endpoints';
import { VoucherFooterButton } from '@/pages/vouchers/VoucherComponent';
import { optionSearchFunction } from '@/utils/common';
import { Table, Checkbox, Form, Input, Modal, Row, Select, Button } from 'antd';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { chunk } from 'lodash';
import { useEffect } from 'react';

const AddLayout = ({
  visible,
  optionList,
  onClose,
  branchList,
  selectedLayout,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { branchId, referenceId } = location.state || [];

  const addLayout = () => {
    if (!selectedLayout) {
      handlePostApi(
        barcodeApiEndPoints.createPrintLayout,
        form.getFieldsValue(),
        setLoading,
        form,
      );
    } else {
      handleUpdatePostApi(
        selectedLayout.referenceId,
        barcodeApiEndPoints.updatePrintLayout,
        form.getFieldsValue(),
        setLoading,
        form,
      );
    }
  };

  const chunkedOptions = chunk(optionList, 4);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ branchId: branchId });

    if (selectedLayout) {
      form.setFieldsValue(selectedLayout);
    }
  }, [selectedLayout, form]);

  return (
    <>
      <Modal
        title={selectedLayout ? 'Edit Layout' : 'Add Layout'}
        open={visible}
        onCancel={onClose}
        footer={null}
        centered
        width={900}
      >
        <Form
          layout="vertical"
          className="username"
          style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}
          form={form}
          onFinish={addLayout}
        >
          <Form.Item
            rules={[{ required: true, message: 'Please input format name' }]}
            label="Format Name"
            name="heading"
            required
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Branch"
            rules={[{ required: true, message: 'Please input branch ID' }]}
            name="branchId"
            required
          >
            <Select
              placeholder="Select branch"
              filterOption={(value, option) => {
                optionSearchFunction(value, option);
              }}
              options={branchList?.map((item) => ({
                value: item.referenceId,
                label: item?.name,
              }))}
            />
          </Form.Item>
          <span>Only 4 Items are allowed</span>

          <Row gutter={[8, 8]} justify="space-between">
            <Form.Item
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || value.length > 4) {
                      return Promise.reject(
                        new Error('You can select up to 4 options'),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              name="tags"
            >
              <Checkbox.Group>
                <Table
                  dataSource={chunkedOptions.map((row, index) => ({
                    key: index,
                    col1: row[0] || null,
                    col2: row[1] || null,
                    col3: row[2] || null,
                    col4: row[3] || null,
                  }))}
                  pagination={false}
                  bordered
                >
                  <Table.Column
                    dataIndex="col1"
                    render={(item) =>
                      item && (
                        <Checkbox value={item.value}>
                          {item.display} ({item.label})
                        </Checkbox>
                      )
                    }
                  />
                  <Table.Column
                    dataIndex="col2"
                    render={(item) =>
                      item && (
                        <Checkbox value={item.value}>
                          {item.display} ({item.label})
                        </Checkbox>
                      )
                    }
                  />
                  <Table.Column
                    dataIndex="col3"
                    render={(item) =>
                      item && (
                        <Checkbox value={item.value}>
                          {item.display} ({item.label})
                        </Checkbox>
                      )
                    }
                  />
                  <Table.Column
                    dataIndex="col4"
                    render={(item) =>
                      item && (
                        <Checkbox value={item.value}>
                          {item.display} ({item.label})
                        </Checkbox>
                      )
                    }
                  />
                </Table>
              </Checkbox.Group>
            </Form.Item>
          </Row>

          <VoucherFooterButton onClose={onClose} />
        </Form>
      </Modal>
    </>
  );
};

export default AddLayout;
